import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { mapGraphQLErrors } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { Schema } from '../../Sections/MultiAnchorSection/schema'
import { toDTO } from './api/mapper'
import { UPDATE_RICH_PLACEMENT_MULTI_ANCHOR } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdateRichPlacementMultiAnchor } from './types'

export const useUpdateRichPlacementMultiAnchor = (): UseUpdateRichPlacementMultiAnchor => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.multiAnchor.action',
  })
  const { workspaceId } = useWorkspaceParam()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_RICH_PLACEMENT_MULTI_ANCHOR,
    onCompleted: async ({
      updateWorkspaceRichPlacementMultianchorConfiguration: result,
    }: Data): Promise<void> => {
      if (result) {
        const { errors } = result

        if (errors && errors.length > 0) {
          setErrors(mapGraphQLErrors(errors))
          enqueueSnackbar(t('error'), { variant: 'error' })
        } else {
          setErrors({})
          enqueueSnackbar(t('success'), { variant: 'success' })
        }
      }
    },
    queriesToInvalidate: ['getRichPlacementMultiAnchor'],
  })

  const update = (data: Schema): void =>
    void mutateAsync({
      input: {
        ...toDTO(data),
        workspaceId,
      },
    })

  return { errors, isPending, update }
}
